import { render } from "./AnswerAnalysis.vue?vue&type=template&id=49f1b7af&scoped=true&ts=true"
import script from "./AnswerAnalysis.vue?vue&type=script&lang=ts"
export * from "./AnswerAnalysis.vue?vue&type=script&lang=ts"

import "./AnswerAnalysis.vue?vue&type=style&index=0&id=49f1b7af&scoped=true&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f1b7af"]])

export default __exports__